import { render } from "./RemoteOperation.vue?vue&type=template&id=d714f59a&scoped=true"
import script from "./RemoteOperation.vue?vue&type=script&lang=js"
export * from "./RemoteOperation.vue?vue&type=script&lang=js"

import "./RemoteOperation.vue?vue&type=style&index=0&id=d714f59a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Samson5\\Scripts\\CVue-Awesome\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d714f59a"]])

export default __exports__